<span class="rating-list" [ngClass]="{'large': large}"> 
    <ngb-rating [max]="4" [rate]="getWidthClass(width)" [readonly]="true">
        <ng-template let-fill="fill">
            <span class="fa fa-exclamation-triangle mr-1 color-{{getWidthClass(width)}}" [class.filled]="fill === 100"></span>
          </ng-template>
    </ngb-rating>
    </span>